import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Container from "partials/Container";
import GridElement from "partials/GridElement";
import Image from "partials/Image";
import IconSelector from "partials/IconSelector";
import SmartLink from "partials/SmartLink";
import Media from "css/Media";

const getLinkUrl = (item) => item.external_url || item.url;

export const LinkList = ({ data, last }) => {
  const [items, setItems] = useState(data);
  const { link_list } = items;

  useEffect(() => {
    setItems(data);
  }, [data]);
  if (!items) return null;
  return (
    <Wrapper>
      {link_list.length > 1 && (
        <Container grid>
          <GridElement
            colStart={{ default: 1, s: 3 }}
            colEnd={{ default: 8, s: 12 }}
            rowStart={1}
            rowEnd={2}
            double
          >
            {items.title && <h3>{items.title}</h3>}
          </GridElement>
          <StyledGridElement
            colStart={{ default: 1, s: 3 }}
            colEnd={{ default: 8, s: 12 }}
            rowStart={items.title ? { default: 2, s: 2 } : { default: 1, s: 1 }}
            rowEnd={items.title ? { default: 4, s: 3 } : { default: 3, s: 2 }}
            double
            last={last}
          >
            <SmartLink to={getLinkUrl(link_list[0])} target={link_list[0].external_url ? "_blank" : undefined}>
              <ImageOverlay>
                <Image image={link_list[0].image} background ratio="5:4">
                  <Gradient>
                    <Caption>
                      <IconSelector icon={link_list[0].icon} negative />
                      <span>{link_list[0].image_text}</span>
                    </Caption>
                  </Gradient>
                </Image>
              </ImageOverlay>
              <span>{link_list[0].text}</span>
            </SmartLink>
          </StyledGridElement>
          <StyledGridElement
            colStart={{ default: 1, s: 13 }}
            colEnd={{ default: 8, s: 22 }}
            rowStart={items.title ? { default: 4, s: 2 } : { default: 3, s: 1 }}
            rowEnd={items.title ? { default: 7, s: 3 } : { default: 7, s: 3 }}
            last={last}
          >
            <SmartLink to={getLinkUrl(link_list[1])} target={link_list[1].external_url ? "_blank" : undefined}>
              <ImageOverlay>
                <Image image={link_list[1].image} background ratio="5:4">
                  <Gradient>
                    <Caption>
                      <IconSelector icon={link_list[1].icon} negative />
                      <span>{link_list[1].image_text}</span>
                    </Caption>
                  </Gradient>
                </Image>
              </ImageOverlay>
              <span>{link_list[1].text}</span>
            </SmartLink>
          </StyledGridElement>
        </Container>
      )}
      {link_list.length === 1 && (
        <Container grid>
          <GridElement
            colStart={{ default: 1, s: 3 }}
            colEnd={{ default: 8, s: 12 }}
            rowStart={1}
            rowEnd={2}
          >
            {items.title && <h3>{items.title}</h3>}
          </GridElement>
          <StyledGridElement
            colStart={{ default: 1, s: 7 }}
            colEnd={{ default: 8, s: 16 }}
            rowStart={items.title ? 2 : 1}
            rowEnd={items.title ? 3 : 2}
            last={last}
          >
            <SmartLink to={getLinkUrl(link_list[0])} target={link_list[0].external_url ? "_blank" : undefined}>
              <ImageOverlay>
                <Image image={link_list[0].image} background ratio="5:4">
                  <Gradient>
                    <Caption>
                      <IconSelector icon={link_list[0].icon} negative />
                      <span>{link_list[0].image_text}</span>
                    </Caption>
                  </Gradient>
                </Image>
              </ImageOverlay>
              <span>{link_list[0].text}</span>
            </SmartLink>
          </StyledGridElement>
        </Container>
      )}
    </Wrapper>
  );
};

export default LinkList;
const Wrapper = styled.section`
  user-select: none;

  .container {
    ${Media.lessThan("s")`
      grid-template-rows: (7, auto);
    `}

    h3 {
      margin-bottom: ${(props) => props.theme.spacing.contentL};
    }
  }
`;

const StyledGridElement = styled(GridElement)`
  padding-bottom: ${(props) =>
    props.last
      ? props.double
        ? props.theme.spacing.elementS
        : 0
      : props.theme.spacing.elementS};
  ${Media.greaterThan("s")`
    padding-bottom: ${(props) => (props.last ? 0 : props.theme.spacing.blockL)};
  `}

  span {
    font-size: 18px;
    font-family: "Untitled";
    line-height: 27px;
    ${Media.greaterThan("s")`
      font-size: 22px;
      line-height: 34px;
    `}
  }
`;

const ImageOverlay = styled.div`
  margin-bottom: 11px;

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    content: "";
    background-color: transparent;
    transition: all 0.2s ease-in;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }

  ${Media.greaterThan("s")`
    margin-bottom: ${(props) => props.theme.spacing.contentS};
  `}

  ${Media.greaterThan("m")`
    margin-bottom: ${(props) => props.theme.spacing.contentL};
  `}
`;

const Gradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 39.74%;
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0)
  );
`;

const Caption = styled.div`
  position: absolute;
  bottom: 35px;
  left: ${(props) => props.theme.spacing.contentXL};
  display: flex;
  align-items: center;
  z-index: 2;

  span {
    font-size: 16px;
    color: ${(props) => props.theme.colors.negative}!important;

    ${Media.greaterThan("s")`
        font-size: 18px;
    `}
  }
`;
